import {useEffect, useRef, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {Col, Modal, Row} from 'react-bootstrap';
import {Button, Form, Input, notification, Select, Spin} from 'antd';
import HelperGeneral from '../../../../helpers/HelperGeneral';
import {trans} from '../../../../helpers/HelperGlobal';
import MaskedInput from 'antd-mask-input';
import Api from '../../../../services/Api';
import {setGlobalSpinner,} from '../../../../services/redux/actions/GeneralAction';
import UserInfo from '../../../auth/UserInfo';
import userInfo from "../../../auth/UserInfo";

const {Option} = Select;
const {TextArea} = Input;

const AddressModal = (props) => {
    const formRef = useRef(null);
    const [show, setShow] = useState(false);
    const [item, setItem] = useState(false);
    const [loading, setLoading] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(undefined);

    const handleClose = () => {
        setShow(false);
        props?.showSend(false);
    }

    const getCounties = (cityId, initialCall = false) => {
        setLoading(true);
        if (!initialCall) {
            formRef.current?.setFieldsValue({countyId: undefined});
        }
        setCounties([]);

        Api.getCounties(cityId).then((e) => {
            setLoading(false);
            setCounties(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    useEffect(() => {
        setLoading(true);

        Api.getCitiesAll().then((e) => {
            setLoading(false);
            setCities(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e)
            setLoading(false);
        })
    }, [])

    useEffect(() => {
        if (item?.county_id) {
            getCounties(item?.city_id, true);
            setSelectedCountry(item?.city_id)
        }
    }, [cities])

    useEffect(() => {
        setShow(props?.show);

        if (Object.keys(props?.item)?.length === 0) {
            const user = UserInfo.info();
            setItem({
                addressFirstName: user?.name,
                addressLastName: user?.surname,
                addressMobilePhone: user?.mobilePhone
            });
        } else {
            setItem(props?.item);
        }
    }, [props])

    const onFinishForm = (values, addressId = null) => {
        setModalLoading(true);
        const user = userInfo.info();
        values.id = addressId;
        values.email = user?.email;
        values.country_id = 225;
        delete values.country;
        if (addressId === null) {
            Api.addressAddOrCreate(values).then(r => {
                setModalLoading(false);
                props?.getAddress();
                handleClose();
                notification['success']({
                    message: 'Başarılı!',
                    description: 'Adresiniz başarılı bir şekilde hesabınıza eklendi',
                })
            }).catch((e) => {
                setModalLoading(false);
                handleClose();
                HelperGeneral.alert(e);
            })
        } else {
            Api.addressAddOrCreate(values, addressId).then(r => {
                setModalLoading(false);
                props?.getAddress();
                handleClose();
                notification['success']({
                    message: 'Başarılı!',
                    description: 'Adresiniz başarılı bir şekilde güncellendi',
                })
            }).catch((e) => {
                setModalLoading(false);
                handleClose();
                HelperGeneral.alert(e);
            })
        }
    }

    return (
        <Modal
            className={'right-modal basket address-modal'}
            show={show}
            onHide={handleClose}
            scrollable={true}
        >
            <Spin spinning={modalLoading}>
                <Form
                    layout={"vertical"}
                    name={""}
                    className={'modal-content'}
                    style={{overflowY: 'auto'}}
                    ref={formRef}
                    initialValues={item}
                    onFinish={(e) => {
                        return item ? onFinishForm(e, item?.id) : onFinishForm(e);
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Adres Detay Formu</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{paddingRight: 15, paddingLeft: 15}}>
                        <Row className={'mt-3'}>
                            <Col xs={12}>
                                <h6 className={'text-center'}>Alıcı Bilgileri</h6>
                                <hr/>
                                <Form.Item
                                    name={"title"}
                                    label={'Adres Başlığı'}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name={"name"}
                                    label={'Ad'}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name={"last_name"}
                                    label={'Soyad'}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name={'telephone'}
                                    label={"Telefon Numarası"}
                                    rules={[
                                        () => ({
                                            required: true,
                                        })
                                    ]}
                                >
                                    <MaskedInput mask={'(\\+90)111-111-11-11'}/>
                                </Form.Item>
                                <h6 className={'text-center mt-3'}>Adres Bilgileri</h6>
                                <hr/>
                                <Form.Item
                                    label={'İl'}
                                    name={"city_id"}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Şehir gerekli bir alan',
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={'Seçiniz'}
                                        className={'w-100'}
                                        loading={loading}
                                        onChange={(value) => {
                                            if (value !== undefined) {
                                                getCounties(value);
                                            } else {
                                                formRef.current?.setFieldsValue({countyId: undefined});
                                            }
                                            setSelectedCountry(value);
                                        }}
                                        allowClear={true}
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                            option?.children?.toLocaleLowerCase('tr')?.includes(input?.toLocaleLowerCase('tr'))
                                        }
                                    >
                                        {
                                            cities?.map((v) => (
                                                <Option value={v?.id}>{v?.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label={'İlçe'}
                                    name={"county_id"}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={'Seçiniz'}
                                        className={'w-100'}
                                        loading={loading}
                                        disabled={selectedCountry === undefined}
                                        allowClear={true}
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                            option?.children?.toLocaleLowerCase('tr')?.includes(input?.toLocaleLowerCase('tr'))
                                        }
                                    >
                                        {
                                            counties?.map((v) => (
                                                <Option value={v?.id}>{v?.title}</Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                <Form.Item
                                    name="address"
                                    label={'Açık Adres'}
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <TextArea rows={4}/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className={'d-block'}>
                        <Col xs={12} className={'d-flex align-items-center justify-content-center text-center'}>
                            <Form.Item className={'btn d-block text-white btn-primary p-0 w-100 m-0'}>
                                <Button
                                    type={"primary"}
                                    htmlType={"submit"}
                                    className={'w-100'}
                                    style={{height: 46}}
                                >
                                    Adresi Kaydet
                                </Button>
                            </Form.Item>
                        </Col>
                        <Row>
                            <Col xs={12} className={'d-flex align-items-center mt-2 justify-content-center text-center'}>
                                <a onClick={handleClose} className={'continue-shop-text text-body'}>
                                    Vazgeç
                                </a>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Form>
            </Spin>
        </Modal>
    )
}

export default withRouter(AddressModal)


